import { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@features/auth'
import { ConfirmModal } from '@shared/ui'
import {
  IconNavHome,
  IconNavMarket,
  IconNavBot,
  IconNavManagement,
  IconNavMypage,
} from '@shared/ui/icons'

type NavTab = 'home' | 'market' | 'bot' | 'management' | 'mypage'

const LOGIN_REQUIRED_TABS: NavTab[] = ['market', 'bot', 'management']

interface NavItem {
  key: NavTab
  label: string
  path: string
  Icon: (props: { color: string }) => React.ReactNode
}

const NAV_ITEMS: NavItem[] = [
  { key: 'home',       label: 'Home',      path: '/',           Icon: IconNavHome },
  { key: 'market',     label: '마켓',       path: '/market',     Icon: IconNavMarket },
  { key: 'bot',        label: '봇',         path: '/bot?strategy=dca', Icon: IconNavBot },
  { key: 'management', label: '관리',       path: '/management', Icon: IconNavManagement },
  { key: 'mypage',     label: '마이페이지', path: '/mypage',     Icon: IconNavMypage },
]

export const MobileNav = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const isLoggedIn = useAuthStore(s => s.isLoggedIn)
  const [loginRequiredPath, setLoginRequiredPath] = useState<string | null>(null)

  const getActive = (path: string) => {
    const pathname = path.split('?')[0]
    if (pathname === '/') return location.pathname === '/'
    return location.pathname.startsWith(pathname)
  }

  const handleClick = (key: NavTab, path: string) => {
    if (!isLoggedIn && LOGIN_REQUIRED_TABS.includes(key)) {
      setLoginRequiredPath(path)
      return
    }

    navigate(path)
  }

  const handleLoginConfirm = () => {
    setLoginRequiredPath(null)
    navigate('/login')
  }

  return (
    <>
      <nav className="fixed bottom-0 left-0 right-0 z-30 h-[74px] w-full border-t-[3px] border-[#373838] bg-[#1b1c1d] pb-4">
        <ul className="flex items-center">
          {NAV_ITEMS.map(({ key, label, path, Icon }) => {
            const active = getActive(path)
            return (
              <li key={key} className="flex-1">
                <button
                  type="button"
                  onClick={() => handleClick(key, path)}
                  className="relative flex w-full flex-col items-center"
                >
                  {/* 활성 탭 상단 노란 바 */}
                  <span
                    className={`-mt-[3px] block h-[3px] w-full ${
                      active ? 'bg-[#faea4d]' : 'bg-transparent'
                    }`}
                  />
                  <span className="flex flex-col items-center gap-2 py-3">
                    <Icon color={active ? '#faea4d' : '#8f9194'} />
                    <span
                      className={`font-pretendard text-[14px] tracking-[-0.35px] ${
                        active
                          ? 'font-semibold text-[#efe9e9]'
                          : 'font-normal text-[#8f9194]'
                      }`}
                    >
                      {label}
                    </span>
                  </span>
                </button>
              </li>
            )
          })}
        </ul>
      </nav>
      <ConfirmModal
        isOpen={!!loginRequiredPath}
        title="로그인이 필요한 메뉴입니다. 로그인 페이지로 이동하시겠습니까?"
        confirmLabel="이동"
        cancelLabel="닫기"
        onConfirm={handleLoginConfirm}
        onCancel={() => setLoginRequiredPath(null)}
      />
    </>
  )
}
